module.exports = __webpack_public_path__ + "static/img/图文4.cb64d5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/图文4.jpg
// module id = IPO7
// module chunks = 1